'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNaN2 = require('lodash/isNaN');

var _isNaN3 = _interopRequireDefault(_isNaN2);

var _bindAll2 = require('lodash/bindAll');

var _bindAll3 = _interopRequireDefault(_bindAll2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _baseStepper = require('./base-stepper');

var _baseStepper2 = _interopRequireDefault(_baseStepper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This specialized stepper only supports positive numbers
 *
 * It can be unrestricted on either end or just one. This can be controlled by specifying
 *  min and max as -1 (infinite) or provided.
 *
 * By default the steppers are infinite on both edges with a step size of 1.
 *
 * @class
 */
var NumStepper = function (_React$Component) {
  _inherits(NumStepper, _React$Component);

  function NumStepper(props) {
    _classCallCheck(this, NumStepper);

    // While this is an anti-pattern, I'm not sure if there's a better way to handle this.
    var _this = _possibleConstructorReturn(this, (NumStepper.__proto__ || Object.getPrototypeOf(NumStepper)).call(this, props));

    var formatter = _this.props.stepSize < 1 && !_this.props.formatter ? '0.00' : _this.props.formatter;

    _this.state = {
      formatter: formatter,
      editing: false,
      value: _this.props.value
    };

    (0, _bindAll3.default)(_this, ['constrainValue', 'getFormattedValue', 'isHandleDisabled', 'handleTextInputFocus', 'handleTextInputChange', 'handleTextInputBlur', 'handleKeyPress', 'handleValueChange', 'handleStep']);
    return _this;
  }

  _createClass(NumStepper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // In case we receive new props - map it back to the state.
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: 'getFormattedValue',
    value: function getFormattedValue(value) {
      if (this.props.formatter && typeof this.props.formatter === 'function') {
        return this.props.formatter(value);
      }

      return (0, _numeral2.default)(value).format(this.state.formatter);
    }
  }, {
    key: 'constrainValue',
    value: function constrainValue(num, manualEdit) {
      var _props = this.props,
          min = _props.min,
          max = _props.max;

      var value = num;

      value = (0, _numeral2.default)(num).value();

      if (min !== -1) {
        value = Math.max(value, this.props.min);
      }

      if (max !== -1) {
        value = Math.min(value, this.props.max);
      }

      // Snapping behavior
      if (!manualEdit && this.props.editable && this.props.snapValues) {
        value = Math.round(value / this.props.stepSize) * this.props.stepSize;
      }

      return value;
    }
  }, {
    key: 'isHandleDisabled',
    value: function isHandleDisabled(direction) {
      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;
      var value = this.state.value;


      if (direction === _baseStepper.ENUM_LEFT && min !== -1) {
        return value === min;
      } else if (direction === _baseStepper.ENUM_RIGHT && max !== -1) {
        return value === max;
      }

      // Let it be enabled if these are infinite steppers.
      return false;
    }
  }, {
    key: 'handleTextInputFocus',
    value: function handleTextInputFocus() {
      this.setState({
        editing: true,
        editedValue: this.getFormattedValue(this.state.value)
      });
    }
  }, {
    key: 'handleTextInputChange',
    value: function handleTextInputChange(event) {
      this.setState({
        editedValue: event.target.value
      });
    }
  }, {
    key: 'handleTextInputBlur',
    value: function handleTextInputBlur() {
      this.handleValueChange(true);
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      if (this.props.updateOnEnter) {
        if (event.charCode === 13) {
          this.handleValueChange();
        }
      }
    }
  }, {
    key: 'handleValueChange',
    value: function handleValueChange() {
      var manualEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = this.state.value;
      var editedValue = this.state.editedValue;


      if (this.props.preformatValue) {
        editedValue = this.props.preformatValue(editedValue);
      }

      var newValue = this.constrainValue(editedValue, manualEdit);

      if ((0, _isNaN3.default)(newValue)) {
        newValue = value;
      }

      this.props.onChange(newValue, value);

      this.setState({
        value: newValue,
        editing: false
      });
    }
  }, {
    key: 'handleStep',
    value: function handleStep(direction, isIntermediate) {
      var value = this.state.value;

      var newValue = this.constrainValue(value + direction * this.props.stepSize);

      // Don't trigger intermediate calls to the user.
      if (!isIntermediate) {
        this.props.onChange(newValue, value);
      }
      // Update the state in case the props aren't going to be changing.
      this.setState({
        value: newValue
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props, {
        onHandleChange: this.handleStep,
        value: this.state.editing ? this.state.editedValue : this.getFormattedValue(this.state.value),
        isHandleDisabled: this.isHandleDisabled
      });

      if (this.props.editable) {
        props = _extends({}, props, {
          hasNumericInput: true,
          onTextInputFocus: this.handleTextInputFocus,
          onTextInputChange: this.handleTextInputChange,
          onTextInputBlur: this.handleTextInputBlur,
          onKeyPress: this.handleKeyPress
        });
      }

      return _react2.default.createElement(_baseStepper2.default, props);
    }
  }]);

  return NumStepper;
}(_react2.default.Component);

NumStepper.displayName = 'NumStepper';
NumStepper.propTypes = {
  editable: _propTypes2.default.bool,
  formatter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  max: _propTypes2.default.number,
  min: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  preformatValue: _propTypes2.default.func,
  snapValues: _propTypes2.default.bool,
  stepSize: _propTypes2.default.number,
  updateOnEnter: _propTypes2.default.bool,
  value: _propTypes2.default.number.isRequired
};
NumStepper.defaultProps = {
  editable: false,
  formatter: null,
  max: -1,
  min: -1,
  onChange: function onChange() {},
  preformatValue: null,
  snapValues: false,
  stepSize: 1,
  updateOnEnter: false
};
exports.default = NumStepper;
NumStepper.__docgenInfo = {
  'description': 'This specialized stepper only supports positive numbers\n\nIt can be unrestricted on either end or just one. This can be controlled by specifying\n min and max as -1 (infinite) or provided.\n\nBy default the steppers are infinite on both edges with a step size of 1.\n\n@class',
  'displayName': 'NumStepper',
  'props': {
    'editable': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'formatter': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'func'
        }]
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'max': {
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '-1',
        'computed': false
      }
    },
    'min': {
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '-1',
        'computed': false
      }
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '() => {}',
        'computed': false
      }
    },
    'preformatValue': {
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'snapValues': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'stepSize': {
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '1',
        'computed': false
      }
    },
    'updateOnEnter': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'value': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    }
  }
};